<template>
  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y full-width :nudge-right="40" max-width="290px" min-width="290px">
    <v-text-field slot="activator" v-bind="$attrs" v-model="fieldValue" :mask="dateMask" @blur="parseDate(fieldValue)" :rules="rules"></v-text-field>
    <v-date-picker v-model="dateValue" no-title scrollable actions @input="menu = false"></v-date-picker>
  </v-menu>
</template>

<script>
  import MomentUtil from '@/components/mixins/MomentUtil'
  import { backendDateTimeFormat } from '@/components/mixins/MomentUtil'
  export default {
    mixins: [MomentUtil],
    props: {
      value: {
        type: [String, Object],
        required: true,
      },
      dateMask: {
        type: String,
        default: '####-##-##',
      },
      dateFormat: {
        type: String,
        default: backendDateTimeFormat,
      },
      rules: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        menu: false,
        fieldValue: '',
        dateValue: '',
        dateValueParsed: null,
      }
    },
    watch: {
      value() {
        this.setFieldValue()
      },
      dateValue(v) {
        this.parseDate(v)
      },
    },
    methods: {
      setFieldValue() {
        this.value ? this.parseDate(this.value) : null
      },
      parseDate(dateText) {
        this.dateValueParsed = this.parseDateTextToMoment(dateText, {
          format: this.dateFormat,
        })

        if (this.dateValueParsed.isValid) {
          this.dateValue = this.dateValueParsed.formattedText
          this.fieldValue = this.dateValueParsed.formattedText
          this.emitChange()
        } else {
          this.fieldValue = dateText
          this.emitChange()
        }
      },
      emitChange() {
        this.$emit('input', this.fieldValue)
      },
    },
    mounted() {
      this.setFieldValue()
    },
  }
</script>

<style scoped>
</style>